module.exports = __webpack_public_path__ + "static/media/logo.a33d4708.png";